module.exports = window["History"];